import styled from 'styled-components';

export default styled.div`
	flex: 1;
	display: flex;
	min-height: 0;
	width: 100%;
	.padding-top-step {
		padding-top: var(--spacing-xx-large);
	}
	.template-padding-sides {
		padding: 0 var(--template-padding-sides);
	}
	.progess-indicator-content {
		> section {
			display: flex;
			flex-direction: column;
			gap: var(--spacing-x-large);
			width: 100%;
		}
	}
	.content-section {
		.header-content {
			display: flex;
			flex-direction: column;
			gap: var(--spacing-large);
		}
	}
	.buttons-section {
		.buttons-content {
			display: flex;
			padding: var(--spacing-x-large) 0;
			gap: var(--spacing-medium);
		}
	}
`;
